import React, { useState, useCallback } from 'react';
import { BlockStack, InlineStack, Text, FormLayout, InlineGrid, TextField, Popover, Button, Divider } from '@shopify/polaris';
import { ViewIcon } from '@shopify/polaris-icons';
import Placeholder from '../common/Placeholder';
import { METAFIELDS_DUMMY_DATA } from '../../utils'

const ViewMetafield = ({ metafields }) => {
    const [popoverActive, setPopoverActive] = useState(false);

    const togglePopoverActive = useCallback(
        () => setPopoverActive((popoverActive) => !popoverActive),
        [],
    );

    const activator = (
        <Button onClick={(e) => {
            e.stopPropagation();
            togglePopoverActive();
        }} icon={ViewIcon} variant='secondary'>
        </Button>
    );

    return (
        <Popover
            active={popoverActive}
            activator={activator}
            onClose={togglePopoverActive}
            ariaHaspopup={false}
            sectioned
            fixed
        >
            <BlockStack gap="100">
                <InlineStack align="space-between" blockAlign="center">
                    <Text variant="headingSm" as="p">
                        Gold Pricing Metafields for This Variant
                    </Text>
                </InlineStack>
                <Text as="span" tone="subdued">
                    These values reflect the current gold rate and related pricing parameters as stored in the variant's metafields. All fields are read-only and cannot be edited here.
                </Text>
            </BlockStack>

            <Placeholder padding='5px var(--p-space-200)' />
            <Divider />
            <Placeholder padding='5px var(--p-space-200)' />
            <FormLayout.Group>
                <InlineGrid gap="200" columns={2}>
                    {metafields?.length > 0 ? metafields.map((key) => (
                        <TextField
                            key={key?.id}
                            label={`${key?.key}`}
                            type="text"
                            value={key?.value}
                            name={key?.key}
                            readOnly
                        />
                    )) :
                        METAFIELDS_DUMMY_DATA.map((key) => (
                            <TextField
                                key={key?.id}
                                label={`${key?.key}`}
                                type="text"
                                value={key?.value}
                                name={key?.key}
                                readOnly
                            />
                        ))
                    }
                </InlineGrid>
            </FormLayout.Group>
        </Popover>
    )
};

export default ViewMetafield;
